<template>
  <div></div>
</template>

<script>
import { Howl, Howler } from "howler";
export default {
  name: "IntroAudio.vue",
  data() {
    return {
      audio: new Howl({
        src: ["static/media/intro.webm", "static/media/intro.mp3"],
        volume: 0,
      }),
    };
  },
  methods: {
    onAudioEnd() {
      this.$eventBus.$emit("audioEnded");
    },
    playAudio() {
      this.audio.on("end", this.onAudioEnd);
      this.audio.play();
      this.audio.fade(0, 0.65, 400);
    },
  },
  mounted() {
    this.$eventBus.$on("onRequestAudio", this.playAudio);
  },
};
</script>
